import React from "react";
import "./BackToTopButton.css";

const BackToTopButton = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button onClick={scrollToTop} className="top-button">
      ↑
    </button>
  );
};

export default BackToTopButton;
